import { render } from "./plan-a.vue?vue&type=template&id=1b81503a"
import script from "./plan-a.vue?vue&type=script&lang=js"
export * from "./plan-a.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__